import { Form } from 'antd';
import { getValueText } from '../../lib';
import { ISelectOption } from '../../model';

interface IProps {
  name?: string;
  label?: string;
  options?: ISelectOption[];
}

export const TextViewField = (props: IProps) => {
  const { label, name } = props;
  return (
    <Form.Item name={name} label={label}>
      <FormTextViewItem />
    </Form.Item>
  );
};

export const SelectViewField = (props: IProps) => {
  const { label, name, options } = props;
  return (
    <Form.Item name={name} label={label}>
      <FormTextViewItem options={options} />
    </Form.Item>
  );
};

export const FormTextViewItem = (props: {
  value?: any;
  options?: ISelectOption[];
}) => {
  const { value, options } = props;
  if (options?.length) {
    return <> {getValueText(value, options)}</>;
  }
  return <>{value}</>;
};
